/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><div :style='[("width: 100vw;height:"+(paddingTop)+"px")] | transRpxStyle' class="fill-box"></div><div class="es-navbar" :class='[$attrs["custom-class"]]'><mpx-view @tap="clickLeft" :style="[({color: leftColor})] | transRpxStyle" class="es-navbar__left"><template v-if="(leftArrow || left)"><es-icon :color="(leftColor)" :size="(leftIconSize)" name="angle-left" v-if="(leftArrow)"></es-icon><span v-if="(left)">{{left}}</span></template><slot name="left" v-else></slot></mpx-view><div class="es-navbar__title custom-title"><span class="es-navbar__text" v-if="(title)">{{title}}</span><slot v-else></slot></div><mpx-view @tap="clickRight" class="es-navbar__right"><span v-if="(right)">{{right}}</span><slot name="right" v-else></slot></mpx-view></div></div></template>

/* styles */
<style lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m15de91ba"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m15de91ba"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex15de91ba%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex15de91ba%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m15de91ba"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index15de91ba/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
